(() => {
  const WebFont = require('webfontloader');
  WebFont.load({
    google: {
      families: ['Sora:200,300,500,600,700:latin-ext']
    }
  });
})();

